import { graphql } from 'gatsby';

import { ImageSwiper } from '@mewa/ui';

import { ComponentProps, PossibleContentSections } from '../fragment-and-types';
import { StrapiImage } from './image';
import { ImageSlide } from './image-slide';

export const QuoteSliderFragment = graphql`
  fragment QuoteSlideshowFragment on STRAPI__COMPONENT_SHARED_QUOTE_SLIDESHOW {
    strapi_component
    quoteSlides {
      quote
      image {
        ...ImageSlideFragment
      }
    }
  }
`;

export const componentName = 'shared.quote-slideshow';

export type QuoteSlideshowData = {
  quoteSlides: {
    quote: string;
    image: ImageSlide;
  }[];
  strapi_component: typeof componentName;
};

export const isQuoteSlideshow = (
  component: PossibleContentSections,
): component is QuoteSlideshowData => {
  return component.strapi_component === componentName;
};

export const StrapiQuoteSlideshow = ({
  quoteSlides,
}: ComponentProps<QuoteSlideshowData>) => {
  const slides = quoteSlides.map((slide) => ({
    image: <StrapiImage responsiveImage={slide.image} />,
    description: `“${slide.quote}”`,
    imageCaptionTitle: slide.image.title,
    imageCaptionText: slide.image.subtitle,
    imageAltText: slide.image.imageAlternativeText,
  }));

  return <ImageSwiper slides={slides} variant="quote" />;
};

export const config = {
  isComponent: isQuoteSlideshow,
  Component: StrapiQuoteSlideshow,
  componentName,
};
